// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebarContainer {
    /* min-height: 30vh; */
    display: flex;
    height: 100%;
    float: right;
    background-color: var(--color-white);
    overflow: hidden;
    border-radius: 0 .75em .75em 0;
    width: 25px;
    transition: width .2s ease-out;
    color:#000;
}
#sidebarContainer.isOpen {
    width: 320px;
}

#sidebarLabel {
    cursor:pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    font-size:0.9rem;
    font-weight: 600;
    padding-top: 10px;
    float: left;
    color: var(--color-white);
    position: relative;
    padding-top: 8px;
    background-color: var(--color-white);
    /* box-shadow: 2px 0px 0px var(--color-primary-green); */
    text-align: center;
}

.sidebar-collapse-icon {
    color: var(--color-primary-orange);
    font-size: 0.9rem;
}

.sidebar-filter-icon {
    color: var(--color-primary-orange);
    font-size: 0.9rem;
}

.sidebar-label-text {
    writing-mode: vertical-rl;
    text-orientation: mixed;
    color: var(--color-primary-orange);
}

#sidebarFilters {
    /* margin-left: 30px; */
    min-width: 290px;
    max-height: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    padding: 10px;
    /* border:3px solid var(--color-primary-green); */
    border-radius:  0 0.75em 0.75em 0;
    display: flex;
    flex-direction: column;
}

.rowTitle {
    cursor: pointer;
    display: flex;
}
.rowTitle:hover{
    background-color: #00000030;
}

.rowTitleText::after {
    display: flex;
    font-family: "Font Awesome 6 Free";
    content: "\\f0d7";
    font-weight: 800;
    padding-right:10px;
    margin-left:auto;
}

.rowTitle.isOpen .rowTitleText::after {
    content: "\\f0d8";
}

.rowFilters {
    max-height: 0px;
    height: auto;
    overflow: hidden;
    transition: max-height .15s ease-out;
}
.rowFilters > div{
    overflow: visible !important;
}
.rowFilters > div > div{
    padding:5px;
    overflow: visible;
}
.rowFilters > div > div > *{
    /* margin-top:10px; */
    margin-bottom:10px;
}

.rowTitle.isOpen+.rowFilters {
    max-height: 500px;
    transition: max-height .15s ease-in;
    animation: .5s delay-overflow;
    overflow: visible;
}

.rowTitleText {
    display: flex;
    width: 230px;
    padding-left: .5rem;
}
.rowTitle.filtered {
    background-color: #0066ff30;
    font-weight: 600;
}

.radio-input:last-child{
    margin-left:20px;
}
#headerTitle{
    /*border-bottom: 1px solid #00000050;
    margin-bottom: 5px;*/
    margin-right: 3px;
    padding-bottom: 5px;
    font-size: 1.3rem;
    flex-shrink: 0;
}

.individualFilterContainer{
    flex: 1 1;
    min-height: 0;
    padding-right: 10px;
    margin-right: -10px;
    overflow-y: auto;
    overflow-x: visible;
    padding-bottom: 20px;
}
.checkboxContainer{
    float:left;
    padding-top:2px;
    padding-left:5px;
    height:13px;
}

.search-container{
   /* padding-left: 8px;
    padding-right:8px;*/
    padding-bottom:4px;
    flex-shrink: 0;
}
.search-input {
    border: 2px solid var(--color-primary-orange);
}
.rowFilters > div > div > div {
    padding-bottom:2px;
    padding-top:2px;
    margin-bottom: 2px;
}

.sidebar-value-input{
    display: flex;
}
.sidebar-value-input .x-icon-container{
    cursor: pointer;
    padding:2px 7px;
    margin-top:6px;
    margin-bottom:5px;
    /* margin-left: -28px; */
    background-color: rgb(226, 48, 48);
    color: var(--color-white);
}
.react-datepicker-wrapper{
    margin-right:2px;
}

@keyframes delay-overflow {
    from {
        overflow: hidden;
    }
}
@media (max-width: 768px) {
  #table-container {
    position: relative;
  }

  #sidebarContainer {
    position: absolute !important;
    top: 42px;   /* pushes below the Export/Clear Filters buttons */
    right: 0;
    height: calc(100% - 42px) !important;
    z-index: 1000;
    border-radius: 0.75em 0 0 0.75em;
  }

  #sidebarContainer.isOpen {
    width: 90% !important;
    max-width: 320px;
  }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/listview/SidebarFilter/SideBarFilters.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,8BAA8B;IAC9B,UAAU;AACd;AACA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,wDAAwD;IACxD,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,iDAAiD;IACjD,iCAAiC;IACjC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;AACxC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI;wBACoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;GACG;uBACoB;IACnB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,6CAA6C;AACjD;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,wBAAwB;IACxB,kCAAkC;IAClC,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,SAAS,IAAI,kDAAkD;IAC/D,QAAQ;IACR,oCAAoC;IACpC,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;AACF","sourcesContent":["#sidebarContainer {\r\n    /* min-height: 30vh; */\r\n    display: flex;\r\n    height: 100%;\r\n    float: right;\r\n    background-color: var(--color-white);\r\n    overflow: hidden;\r\n    border-radius: 0 .75em .75em 0;\r\n    width: 25px;\r\n    transition: width .2s ease-out;\r\n    color:#000;\r\n}\r\n#sidebarContainer.isOpen {\r\n    width: 320px;\r\n}\r\n\r\n#sidebarLabel {\r\n    cursor:pointer;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size:0.9rem;\r\n    font-weight: 600;\r\n    padding-top: 10px;\r\n    float: left;\r\n    color: var(--color-white);\r\n    position: relative;\r\n    padding-top: 8px;\r\n    background-color: var(--color-white);\r\n    /* box-shadow: 2px 0px 0px var(--color-primary-green); */\r\n    text-align: center;\r\n}\r\n\r\n.sidebar-collapse-icon {\r\n    color: var(--color-primary-orange);\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.sidebar-filter-icon {\r\n    color: var(--color-primary-orange);\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.sidebar-label-text {\r\n    writing-mode: vertical-rl;\r\n    text-orientation: mixed;\r\n    color: var(--color-primary-orange);\r\n}\r\n\r\n#sidebarFilters {\r\n    /* margin-left: 30px; */\r\n    min-width: 290px;\r\n    max-height: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    overflow: hidden;\r\n    padding: 10px;\r\n    /* border:3px solid var(--color-primary-green); */\r\n    border-radius:  0 0.75em 0.75em 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.rowTitle {\r\n    cursor: pointer;\r\n    display: flex;\r\n}\r\n.rowTitle:hover{\r\n    background-color: #00000030;\r\n}\r\n\r\n.rowTitleText::after {\r\n    display: flex;\r\n    font-family: \"Font Awesome 6 Free\";\r\n    content: \"\\f0d7\";\r\n    font-weight: 800;\r\n    padding-right:10px;\r\n    margin-left:auto;\r\n}\r\n\r\n.rowTitle.isOpen .rowTitleText::after {\r\n    content: \"\\f0d8\";\r\n}\r\n\r\n.rowFilters {\r\n    max-height: 0px;\r\n    height: auto;\r\n    overflow: hidden;\r\n    transition: max-height .15s ease-out;\r\n}\r\n.rowFilters > div{\r\n    overflow: visible !important;\r\n}\r\n.rowFilters > div > div{\r\n    padding:5px;\r\n    overflow: visible;\r\n}\r\n.rowFilters > div > div > *{\r\n    /* margin-top:10px; */\r\n    margin-bottom:10px;\r\n}\r\n\r\n.rowTitle.isOpen+.rowFilters {\r\n    max-height: 500px;\r\n    transition: max-height .15s ease-in;\r\n    animation: .5s delay-overflow;\r\n    overflow: visible;\r\n}\r\n\r\n.rowTitleText {\r\n    display: flex;\r\n    width: 230px;\r\n    padding-left: .5rem;\r\n}\r\n.rowTitle.filtered {\r\n    background-color: #0066ff30;\r\n    font-weight: 600;\r\n}\r\n\r\n.radio-input:last-child{\r\n    margin-left:20px;\r\n}\r\n#headerTitle{\r\n    /*border-bottom: 1px solid #00000050;\r\n    margin-bottom: 5px;*/\r\n    margin-right: 3px;\r\n    padding-bottom: 5px;\r\n    font-size: 1.3rem;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.individualFilterContainer{\r\n    flex: 1;\r\n    min-height: 0;\r\n    padding-right: 10px;\r\n    margin-right: -10px;\r\n    overflow-y: auto;\r\n    overflow-x: visible;\r\n    padding-bottom: 20px;\r\n}\r\n.checkboxContainer{\r\n    float:left;\r\n    padding-top:2px;\r\n    padding-left:5px;\r\n    height:13px;\r\n}\r\n\r\n.search-container{\r\n   /* padding-left: 8px;\r\n    padding-right:8px;*/\r\n    padding-bottom:4px;\r\n    flex-shrink: 0;\r\n}\r\n.search-input {\r\n    border: 2px solid var(--color-primary-orange);\r\n}\r\n.rowFilters > div > div > div {\r\n    padding-bottom:2px;\r\n    padding-top:2px;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.sidebar-value-input{\r\n    display: flex;\r\n}\r\n.sidebar-value-input .x-icon-container{\r\n    cursor: pointer;\r\n    padding:2px 7px;\r\n    margin-top:6px;\r\n    margin-bottom:5px;\r\n    /* margin-left: -28px; */\r\n    background-color: rgb(226, 48, 48);\r\n    color: var(--color-white);\r\n}\r\n.react-datepicker-wrapper{\r\n    margin-right:2px;\r\n}\r\n\r\n@keyframes delay-overflow {\r\n    from {\r\n        overflow: hidden;\r\n    }\r\n}\r\n@media (max-width: 768px) {\r\n  #table-container {\r\n    position: relative;\r\n  }\r\n\r\n  #sidebarContainer {\r\n    position: absolute !important;\r\n    top: 42px;   /* pushes below the Export/Clear Filters buttons */\r\n    right: 0;\r\n    height: calc(100% - 42px) !important;\r\n    z-index: 1000;\r\n    border-radius: 0.75em 0 0 0.75em;\r\n  }\r\n\r\n  #sidebarContainer.isOpen {\r\n    width: 90% !important;\r\n    max-width: 320px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
